import React, { useState } from 'react';
import Navbar from './global-components/navbar';
import BannerV2 from './section-components/banner';
import Trending from './section-components/trending-v3';
import Catv2 from './section-components/cat-section-v2';
import NewsLatter from './section-components/newsletter';
import Footer from './global-components/footer';
import Loader from './global-components/loader';
import { Helmet } from 'react-helmet';

const Home_V2 = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      <Helmet>
    <title>Home - tagIt's News | Amplifying Muslim Voices</title>
    <meta name="description" content="Welcome to tagIt's News. Stay updated with the latest stories, opinions, and analyses tailored for the Muslim community worldwide." />
    <meta name="keywords" content="Muslim news, community news, global news, opinions, latest stories" />
    <meta name="author" content="tagIt's News" />
</Helmet>


      <Navbar />
      {/* {loading && <div style={{display: "flex", justifyContent: "center", marginTop: 10, gap: 20}}><Loader /> <Loader /> <Loader /></div>} Show loader when loading is true */}
      <BannerV2 setParentLoading={setLoading} />
      <Trending setParentLoading={setLoading}/>
      <Catv2 />
      <NewsLatter />
      <Footer />
    </div>
  );
};

export default Home_V2;
